<template>
    <div>
<!--        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>-->
        <div class="container">
            <el-form :inline="true" class="demo-form-inline" style="height: 90px">
              <el-form-item label="客户订单编号">
                <el-input style="width: 220px" placeholder="请输入订单编号" v-model="queryParams.ordersn" clearable></el-input>
              </el-form-item>
              <el-form-item label="售后单号:">
                <el-input placeholder="请输入售后单号" v-model="queryParams.order_right_sn" clearable></el-input>
              </el-form-item>
              <el-form-item label="售后id:">
                <el-input placeholder="请输入售后id" v-model="queryParams.id" clearable></el-input>
              </el-form-item>
              <el-form-item label="收件物流:" >
                <el-select v-model="queryParams.expresscom" placeholder="收件物流" class="handle-select form-input" style="width: 150px" clearable>
                  <el-option v-for="items in expressList" :key="items.id" :label="items.name" :value="items.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收件物流单:" >
                <el-input placeholder="请输入收件物流单" v-model="queryParams.expresssn" clearable ></el-input>
              </el-form-item>
              <el-form-item label="提交时间:" prop="time">
                <el-date-picker ref="drawDate" style="margin-left: 5px;" v-model="queryParams.time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="changeQuery">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="寄回姓名:">
                <el-input placeholder="请输入用户寄回姓名" v-model="queryParams.send_2u_name" clearable></el-input>
              </el-form-item>
              <el-form-item label="寄回手机号:">
                <el-input placeholder="请输入用户寄回手机号" v-model="queryParams.send_2u_mobile" clearable></el-input>
              </el-form-item>
              <el-form-item label="商品型号:">
                <el-input placeholder="请输入商品型号" v-model="queryParams.order_goods_name" clearable></el-input>
              </el-form-item>
              <el-form-item label="售后状态:">
                <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @change="changState">
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button v-for="(state,index) in repairStateMap" :label="index" :key="index">{{state.admin}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button type="primary" @click="changeQuery()">筛选</el-button>
                <el-button type="primary" @click="exportFile">导出</el-button>
              </el-form-item>
            </el-form>

            <!-- 表格内容 -->
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable" style="margin-top:20px">
              <el-table-column label="单号" fixed="left" width="280">
                <template slot-scope="scope">
                  <el-row class="table-block-head">
                    <span>{{ scope.row.order_right_sn }}</span><span style="color: #3a8ee6">{{scope.row.id}}</span> <br>
                    <span>订单:{{ scope.row.ordersn }}</span>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column label="商品信息" fixed="left" width="300">
                <template slot-scope="scope" v-if="scope.row.order_register">
                  <el-row>
                    <el-col :span="10" v-if="scope.row.order_register">
                      <div class="head-box">
                        <el-image @click="showBigImg(scope.$index)" style="height:48px;width:48px" fit="cover"
                                  :class="`column${scope.$index}`" :src="scope.row.order_register.product_img"
                                  :preview-src-list="[scope.row.order_register.product_img]">
                          <div slot="error" class="image-slot">
                            <el-image fit="cover" :src="defaultImg"></el-image>
                          </div>
                        </el-image>
                        <el-image @click="showBigImg(scope.$index)" style="height:48px;width:48px" fit="cover"
                                  :class="`column${scope.$index}`" :src="scope.row.order_register.bought_ticket"
                                  :preview-src-list="[scope.row.order_register.bought_ticket]">
                          <div slot="error" class="image-slot">
                            <el-image fit="cover" :src="defaultImg"></el-image>
                          </div>
                        </el-image>
                      </div>
                    </el-col>
                    <el-col :span="14">
                      <div class="msg-box">
                        <span class="name">{{ scope.row.order_register.order_goods_name }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="uid" label="用户" width="250" align="center">
                <template slot-scope="scope">
                  <el-row v-if="scope.row.user">
                    <div class="head-box">
                      <!--  头像  -->
                      <div class="user-avatar-box">
                        <el-image @click="showBigImg(scope.$index)" style="height:40px;width:40px" fit="cover"
                                  :class="`column${scope.$index}`" :src="scope.row.user.avatar"
                                  :preview-src-list="[scope.row.user.avatar]">
                          <div slot="error" class="image-slot">
                            <el-image fit="cover" :src="defaultImg"></el-image>
                          </div>
                        </el-image>
                      </div>
                      <div class="user-msg-box">
                        <span class="name">{{ scope.row.user.nickname }}</span>
                        <div class="tel">{{ scope.row.user.phone }}</div>
                      </div>
                    </div>
                  </el-row>
                  <el-row v-else>
                    无用户信息
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="50" align="center">1</el-table-column>
              <el-table-column prop="expresssn" label="售后收件" width="160" align="center">
                <template slot-scope="scope">
                  <el-row class="">
                    <span>{{ scope.row.express.name }}</span><br>
                    <span>{{ scope.row.expresssn }}</span>
                    <el-button type="text"   @click="updateExpresssnShow(scope.row)" class="green">修改</el-button><br>
                  </el-row>
                </template>
              </el-table-column>
                <el-table-column prop="express_to_u" label="寄回用户" width="160" align="center">
                    <template slot-scope="scope" v-if="scope.row.expresssn_to_u">
                        <el-row class="table-block-head"  v-if="scope.row.express_to_u!==null && scope.row.express_to_u !== undefined">
                            <span>{{scope.row.express_to_u.name}}</span> <span class="edit-text-btn" @click="saleSendVisibleShow(scope.row,'update')">修改</span><br>
                            <span>{{scope.row.expresssn_to_u}}</span>
                        </el-row>
                        <el-row v-else>
                            <el-button type="text" v-if="scope.row.state >=20 &&scope.row.state <=50 "  @click="saleSendVisibleShow(scope.row,'create')">填写快递单号</el-button>
                        </el-row>
                    </template>
                </el-table-column>                <el-table-column prop="expresssn" label="寄回地址" width="350" align="center">
                    <template slot-scope="scope">
                        <div>[{{ scope.row.user_addr.username }} - {{ scope.row.user_addr.phone }}】
                            <span  class="edit-text-btn"
                                v-clipboard:copy="scope.row.user_receive_addr"
                                v-clipboard:success="copyUsrReceiveAddrSuccess"
                                v-clipboard:error="copyUsrReceiveAddrError"
                               >复制
                            </span>
                        </div>
                        <div class="send-back-addr">{{ scope.row.user_addr.province }}/{{scope.row.user_addr.city}}/{{ scope.row.user_addr.area }}/{{ scope.row.user_addr.address }}
                        </div>
                    </template>
                </el-table-column>
              <el-table-column prop="reason" label="故障描述" width="150" align="center"></el-table-column>
              <el-table-column prop="state_str.admin" label="订单状态" align="center" width="100"></el-table-column>
              <el-table-column prop="after_handle_type_str" label="检测状态" align="center" width="100"></el-table-column>
              <el-table-column prop="ctime" label="提交时间" align="center" width="160"></el-table-column>
              <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">

                    <el-button type="text" v-if="scope.row.state ===0" @click="updateState(scope.row.id,3)" class="green">通过申请</el-button>
                        <el-button type="text" v-if="scope.row.state ===0" @click="updateState(scope.row.id,1)" class="green">拒绝申请</el-button>
                        <div v-if=" scope.row.state !==1 &&  scope.row.state!==2">
                            <el-button type="text" v-if=" scope.row.state ===3 " @click="confirmSaleReceived(scope.row)" class="green">确认收件</el-button>
                            <el-button type="text" v-if="scope.row.state ===20 " @click="updateState(scope.row.id,30)" class="green">开始检测</el-button>
                            <el-button type="text" v-if="scope.row.state ===30 " @click="updateAfterHandelTypeShow(scope.row.id,50)" class="green">检测完成</el-button>

                        </div>
                        <el-button type="text" v-if="scope.row.state >=60" @click="updateState(scope.row.id,2)" class="green">完成</el-button>
                        <el-button type="text" v-if="scope.row.state >=20 &&scope.row.state <=50 && scope.row.express_to_u ===null"  @click="saleSendVisibleShow(scope.row,'create')">填写快递单号</el-button>
                        <el-button type="text" v-if="scope.row.state >=20 &&scope.row.state <=50"  @click="updateState(scope.row.id,60)">寄出完成</el-button>
                        <el-button type="text"  @click="deleteRow(scope.row.id)">  <el-link type="danger">删除</el-link></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 上线、下线提示框 -->
        <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
            <div class="del-dialog-cnt">{{ confirmContent }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="stateData">确 定</el-button>
            </span>
        </el-dialog>
        <!--   售后收件 确认      -->
        <el-dialog title="确认收货" :visible.sync="confirmSaleReceivedShow" width="500px">
            <div class="del-dialog-cnt">
                <el-row> 确认已经收到客户已寄出的维修物品吗？</el-row>
                <br>
                <el-row>
                    <el-col :span="12">
                        <el-image v-for="(image ,index) in  rightTmp.imagesList" :key="index" style="height:128px;width:auto" fit="cover" :src="image">
                            <div slot="error" class="image-slot">
                                <el-image v fit="cover" :src="defaultImg"></el-image>
                            </div>
                        </el-image>
                    </el-col>
                    <el-col :span="12">
                        <br><el-row>产品类型：{{rightTmp.productCate}}</el-row>
                        <br><el-row>产品型号：{{rightTmp.productModel}}</el-row>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmSaleReceivedState(rightTmp.id)">确 定</el-button>
            </span>
        </el-dialog>

        <!--   填写售后收件快递单号     -->
        <el-dialog title="填写回寄快递单号" :visible.sync="expresssnFormShow" width="300px" center>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-select placeholder="请选择物流公司" v-model="expresssnForm.expresscom" aria-placeholder="请选择物流公司">
                        <el-option v-for="item in expressList" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入快递单号" v-model="expresssnForm.expresssn"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updateReceiveExpress( rightTmp.id)"><span v-if="this.expressSaveType==='create'">保存</span><span v-if="this.expressSaveType==='update'">修改</span>单号</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--   填写回寄快递单号     -->
        <el-dialog title="填写回寄快递单号" :visible.sync="saleSendVisible" width="300px" center>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-select placeholder="请选择物流公司" v-model="expressComId" aria-placeholder="请选择物流公司">
                        <el-option v-for="item in expressList" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入快递单号" v-model="expresssn"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.expressSaveType==='create'" type="primary" @click="deliver(true)">发货</el-button>
                    <el-button type="primary" @click="deliver(false)"><span v-if="this.expressSaveType==='create'">保存</span><span v-if="this.expressSaveType==='update'">修改</span>单号</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--   售后处理方式选择  afterHandelTypeShow    -->
        <el-dialog title="检测" :visible.sync="afterHandelTypeShow" width="400px" center>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-radio-group v-model="afterHandelTypeForm.after_handle_type">
                        <el-radio
                            style="display: block; margin-bottom: 10px;"
                            v-for="(item, key) in afterHandelTypeDict"
                            :key="key"
                            :label="parseInt(key)">
                            {{ item.admin }}

                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <br>
                <el-form-item>
                    <el-button type="primary" @click="updateAfterHandelType">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import {request} from '@/common/request';
import {deal} from '@/common/main';
import {mapMutations} from 'vuex';

export default {
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            tabPosition: 'all',
            defaultImg: require('../../assets/img/zhan.jpeg'),
            menuList: ['订单', '售后订单'],
            pageInfo: {
                list: [],
            },
            goodsList: [],
            show: false,
            confirmSaleReceivedShow:false,
            saleSendVisible:false,
            logisticsVisible: false,
            confirmContent: '',
            confirmVisible: false,
            makeMoneyVisible: false,
            expresssnFormShow: false,
            afterHandelTypeShow: false, // 售后处理方式弹窗
            refunt_state: 0,
            choseState: 0,
            refunt_id: 0,
            pay_number: '',
            repairStateMap:[],
            afterHandelTypeDict:{
                    "10": {
                        "admin": "正常寄回",
                        "r": "10",
                        "user": "正常寄回"
                    },
                "20": {
                    "admin": "在保中换新",
                    "r": "20",
                    "user": "在保中换新"
                },
                "30": {
                    "admin": "折价换新",
                    "r": "30",
                    "user": "折价换新"
                },
                "40": {
                    "admin": "其他，可咨询客服",
                    "r": "40",
                    "user": "其他，可咨询客服"
                }
            },

            expressList: [],
            expresssn:[],
            expressComId:0,
            expressSaveType:'create',
            expresssnForm:{
                expresssn:'',
                expresscom :0
            },
            rightTmp:{
                productCate:"",
                productModel:""
            },
            afterHandelTypeForm:{
                id:0,
                after_handle_type:0 ,
            }
        }
    },
    computed: {
        queryParams: {
            set: function (newValue) {
                console.log(111111, newValue)
                this.$store.commit('initQueryParams', newValue)
            },
            get: function (newValue) {
                return this.$store.state.queryParams
            },
        }
    },
    created() {
        this.loadConfig()
        this.getExpressList()
        if (this.queryParams.state) {
            if (this.queryParams.state === 1) {
                this.tabPosition = 1
            }
            if (this.queryParams.state === 2) {
                this.tabPosition = 2
            }
            if (this.queryParams.state === 3) {
                this.tabPosition = 3
            }
            if (this.queryParams.state === 4) {
                this.tabPosition = 4
            }
        } else if (this.queryParams.is_complete) {
            if (this.queryParams.is_complete === 2) {
                this.tabPosition = 5
            }
        } else {
            this.tabPosition = 'all'
        }
        this.loadData()



    },
    watch: {
        $route(from) {
            let ArticleEdit = from.fullPath.indexOf('/order-RefundDetail')
            if (ArticleEdit !== -1) {
                this.loadData()
            }
        }
    },
    methods: {
        ...mapMutations({
            'initQueryParams': 'initQueryParams'
        }),
        // 导出
        exportFile() {
            if (this.queryParams.ctime && this.queryParams.etime) {
                request.get('/return/export', { stime: this.queryParams.ctime, etime: this.queryParams.etime }).then(ret => {
                    if (ret.code === 1) {
                        this.$message.success('导出成功');
                    } else {
                        this.$message.error(ret.msg);
                    }
                });
            } else {
                this.$message.error('请选择时间');
            }

        },
        // 查看大图
        showBigImg(index) {
            this.$nextTick(function () {
                let shows = document.getElementsByClassName(`column${index}`)
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper')
                show[0].style['display'] = 'block'
                let dom = show[0].getElementsByClassName('el-image-viewer__mask')
                dom[0].addEventListener('click', function () {
                    show[0].style['display'] = 'none'
                })
            })
        },
        state(id, type) {
            this.refunt_id = id;
            if (type === "refuse") {
                this.refunt_state = 3;
                this.confirmContent = '确认拒绝'
            } else {
                this.refunt_state = 2;
                this.confirmContent = '确认通过'
            }
            this.confirmVisible = true
        },

        saleSendVisibleShow(row, typeStr) {
            this.expressSaveType = typeStr
            this.expresssn = ""
            this.expressComId = 0
            if (typeStr === 'update') {
                this.expresssn = row.expresssn_to_u
                this.expressComId =parseInt( row.expresscom_to_u)
            }
            this.rightTmp.id = row.id
            this.saleSendVisible = true
        },

        updateExpresssnShow(row){
            this.rightTmp.id = row.id
            this.expresssnFormShow =true
            this.expresssnForm.expresssn = row.expresssn
            this.expresssnForm.expresscom = parseInt(row.expresscom) // 或者 String(row.expresscom)
        },

        confirmSaleReceived(rightTmp){
            this.rightTmp=rightTmp
            if (this.rightTmp.images.length>5){
                this.rightTmp.imagesList=JSON.parse(this.rightTmp.images)
            }else {
                this.rightTmp.imagesList=["",""]
            }


            //分割型号出来
            var  goodsNameSplit;
            var goodsName = rightTmp.order_register.order_goods_name;
            // 在每个空格字符处进行分解。
            goodsNameSplit = goodsName.split("/");
            if (goodsNameSplit.length === 3){
                this.rightTmp.productCate=goodsNameSplit[0]+"/"+goodsNameSplit[1]
                this.rightTmp.productModel=goodsNameSplit[1]
            }
            this.confirmSaleReceivedShow=true
        },
        confirmSaleReceivedState(id) {
            this.confirmSaleReceivedShow = false
            this.updateState(id, 50)
        },

        loadData() {
            this.loading = true;
            // 获取售后订单列表
            request.get('/order/rights/mini/list', this.queryParams).then(ret => {
                if (ret.code === 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    for (const rightItem of this.pageInfo.list) {
                        if (rightItem.user_addr !==undefined && rightItem.user_addr!==null){
                            rightItem.user_receive_addr = rightItem.user_addr.username
                                +' '+ rightItem.user_addr.phone
                                +' '+ rightItem.user_addr.province
                                + rightItem.user_addr.city
                                + rightItem.user_addr.area
                                + rightItem.user_addr.address
                        }else {
                            rightItem.user_receive_addr = "地址信息 错误"
                        }
                    }

                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        loadConfig() {
            this.loading = true;
            // 获取售后订单列表
            request.get('/order/rights/get/config', {}).then(ret => {
                if (ret.code === 1) {
                    this.repairStateMap=ret.data.order_right_mini_repair_state
                    this.afterHandelTypeDict=ret.data.order_right_mini_check_state
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        changState() {
            this.queryParams.page = 1
            this.queryParams.pagesize = 10
            switch (this.tabPosition) {
                case 'all':
                    delete this.queryParams.is_complete
                    delete this.queryParams.state
                    break;
               default:
                   this.queryParams.state = this.tabPosition
                   break;
            }
            this.loadData()
        },

        updateState(rightId,stateEnum){
            request.post('/order/rights/mini/edit', {id:rightId,state:stateEnum}).then(ret => {
                if (ret.code === 1) {
                    this.$message.success("操作成功")
                    this.loadData()
                } else {
                    this.$message.error(ret.msg)
                }
            });
        },
        // 修改售后处理方式
        updateAfterHandelType() {


            // 发送请求到后端接口
            request.post('/order/rights/mini/afterHandelType/edit', this.afterHandelTypeForm).then(ret => {
                if (ret.code === 1) {
                    this.afterHandelTypeShow = false; // 关闭弹窗
                    this.loadData(); // 重新加载数据
                } else {
                    this.$message.error(ret.msg || '操作失败');
                }
                this.updateState(this.afterHandelTypeForm.id, 50)
            }).catch(err => {
                this.$message.error('网络异常，请稍后再试');
                console.error('请求错误:', err);
            });
        },
        updateAfterHandelTypeShow(id){
            this.afterHandelTypeShow = true
            this.afterHandelTypeForm.id = id
        },
        updateReceiveExpress(rightId){
            let data =this.expresssnForm
            data.id = rightId
            request.post('/order/rights/edit', data).then(ret => {
                if (ret.code === 1) {
                    this.$message.success("操作成功")
                    this.loadData()
                } else {
                    this.$message.error(ret.msg)
                }
            });
        },



        deleteRow(id){
            this.$confirm('此操作将永久删除该售后记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request.post('/order/rights/mini/delete', {id:id}).then(ret => {
                    if (ret.code === 1) {
                        this.$message.success("删除成功")
                        this.loadData()
                    } else {
                        this.$message.error(ret.msg)
                    }
                });
                return false
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        } ,
        // 分页
        changeQuery() {
            this.queryParams.page = 1;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        stateData() {
            request.post('/order/rights/mini/edit', { id: this.refunt_id, state: this.refunt_state }).then(ret => {
                if (ret.code === 1) {
                    this.loading = false;
                    this.loadData();
                } else {
                    this.$message.error(ret.msg);
                }
                this.confirmVisible = false
            });
        },
        // 查看详情
        goDetail(id) {
            this.$router.replace({ path: '/order-RepairMiniDetail', query: { 'id': id } })
        },
        // 获取所有物流公司
        getExpressList() {
            request.get('/common/express/list', { page: 1, pagesize: -1, state: 2 }).then(ret => {
                if (ret.code === 1) {
                    this.expressList = ret.data.list
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        deliver(delivers) {
            let data = {
                id: this.rightTmp.id,
                expresscom: this.expressComId,
                expresssn: this.expresssn,
                onlySaveExpress:!delivers
            }
            request.post('/order/rights/send2user/mini', data).then(ret => {
                if (ret.code === 1) {
                    this.$message.success('回寄成功');
                    this.saleSendVisible=false
                    this.loadData()
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        copyUsrReceiveAddrSuccess(e){
            this.$notify.success({
                title: '复制成功',
                message: '寄回信息：'+e.text,
                showClose: false
            });
        },
        copyUsrReceiveAddrError(err){
            //console.log(err)
        }

    }
};
</script>

<style lang="scss" scoped>
.container{
  padding: 5px 20px;
}
.table-block-head{
    height: 20px;
    width: 100%;
    margin-bottom:20px ;
}
.table-block-head span{
    font-weight: bold;
    font-size: 14px;
}
.table-block-head span:nth-child(2){
    margin-left: 20px;
}
.el-table__body .cell{
    padding: 0;
}

.user-avatar-box{
    float: left;
    margin-left: 40px;
}
.user-msg-box{
    margin-left: 40px;
    float: left;
}
.edit-text-btn{
    color: #3a8ee6;
    font-size: 14px
}

.send-back-addr{
  font-size: 14px;
}
</style>
